<h2 mat-dialog-title i18n style="margin-bottom: 15px">
    Open Project
    @if (isExport) {
        <span>USA</span>
    }
</h2>

<mat-dialog-content class="dialog-content">
    <div class="form-grid">
        <!-- Row 1: Key Metadata -->
        <mat-form-field appearance="outline">
            <mat-label i18n>Project Nr.</mat-label>
            <input
                    matInput
                    [formControl]="projectNr"
                    maxlength="6"
                    aria-label="Project Number">
            @if (projectNr.invalid) {
                <mat-error>{{ getErrorMessage() }}</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label i18n>Final Offer</mat-label>
            <input
                    matInput
                    type="number"
                    [formControl]="finalOffer"
                    aria-label="Final Offer">
            <mat-icon matSuffix>{{ isExport ? 'attach_money' : 'euro' }}</mat-icon>
        </mat-form-field>

        <!-- Row 2: Management & Payment -->
        <div class="field-container">
            <app-user-picker
                    [myControl]="projectManager"
                    placeholder="Project Manager">
            </app-user-picker>
        </div>

        <mat-form-field appearance="outline">
            <mat-label i18n>Payment Method</mat-label>
            <mat-select [formControl]="paymentMethod">
                @for (pm of paymentMethodOptions; track pm.methodCode) {
                    <mat-option [value]="pm.methodValue">
                        {{ pm.methodValue }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>

        <!-- Row 3: Schedule -->
        <mat-form-field appearance="outline" class="full-width">
            <mat-label i18n>Delivery Date</mat-label>
            <input
                    matInput
                    [matDatepicker]="deliveryFormDate"
                    [formControl]="deliveryDate"
                    [min]="minDeliveryDate">
            <mat-datepicker-toggle matSuffix [for]="deliveryFormDate"></mat-datepicker-toggle>
            <mat-datepicker #deliveryFormDate></mat-datepicker>
        </mat-form-field>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="onNoClick()" i18n>Cancel</button>
    <button
            mat-flat-button
            color="primary"
            type="submit"
            [disabled]="!isValid"
            (click)="closeDialog()"
            i18n>
        Submit
    </button>
</mat-dialog-actions>